module.exports = __webpack_public_path__ + "static/media/lqeLogo.0e84decf.jpg";